import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class AdvisoryInput extends Component {
  // Render

  render() {
    const { max, min, name, onChange, placeholder, value, unit } = this.props;

    return (
      <div className="advisory-input">
        <input
          className="advisory-input__input"
          max={max}
          min={min}
          name={name}
          onChange={onChange}
          placeholder={placeholder}
          type="number"
          value={value}
        />
        <div className="advisory-input__unit">
          {unit}
        </div>
      </div>
    );
  }
}

AdvisoryInput.propTypes = {
  max: PropTypes.number,
  min: PropTypes.number,
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.number,
  unit: PropTypes.string,
};



// WEBPACK FOOTER //
// ./js/components/advisory-input/index.jsx